// Lib
import React, { useCallback } from 'react';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import { useLocation } from 'react-router-dom';

// Components
import Button from '../../Button';
import Select from '../../Field/Select';
import SortButton from '../../Button/SortButton';
import Feather from '../../Feather';
import capitalize from '../../../utils/capitalize';

// Styles
import { useStyles } from './FiltersBoxStyles';

const FiltersBox = ({
  filters,
  isMobileMode = false,
  onAddAddress,
  onChangeSorting,
  isAddressBookPage = true,
  importAddresses,
}) => {
  const { classes } = useStyles();

  const { pathname } = useLocation();
  const isCartPage = pathname === '/cart/shipping-address';

  const renderBox = useCallback(() => {
    if (isMobileMode && isCartPage) {
      return (
        <Button
          onClick={onAddAddress}
          variant="text"
          className={classes.iconButton}
          data-testid={'add-address-button'}>
          <Feather type="plus" />
        </Button>
      );
    }
    if (isMobileMode && !isAddressBookPage) {
      return <></>;
    }
    if (isMobileMode && isAddressBookPage) {
      return (
        <Box display="flex" gap={2}>
          <Button
            onClick={onAddAddress}
            variant="text"
            className={classes.iconButton}
            data-testid={'add-address-button'}>
            <Feather type="plus" />
          </Button>
          <Button
            variant="text"
            className={classes.iconButton}
            onClick={importAddresses}
            data-testid="import-address-button">
            <Feather strokeWidth="2px" type="arrowDown" printType="stroke" />
          </Button>
        </Box>
      );
    }

    const renderImportAddressButton = () => {
      if (isAddressBookPage) {
        return (
          <Button
            variant="text"
            styles={{ fontSize: 14 }}
            onClick={importAddresses}
            data-testid="import-address-button">
            <Feather
              strokeWidth="2px"
              type="arrowDown"
              printType="stroke"
              className={classes.filterIcon}
            />
            Import Addresses
          </Button>
        );
      }
    };
    const renderAddNewAddressButton = () => {
      if (isAddressBookPage || isCartPage) {
        return (
          <Button
            styles={{
              order: isCartPage ? 1 : 0,
              marginLeft: isCartPage ? 'auto' : 0,
            }}
            onClick={onAddAddress}
            className={classes.button}
            variant="text"
            data-testid="add-address-button">
            <AddIcon className={classes.plusIcon} />
            <span>Add New Address</span>
          </Button>
        );
      }
    };
    return (
      <>
        <Box display="flex" gap={4} width={isCartPage ? '100%' : 'auto'}>
          {renderAddNewAddressButton()}
          <Box display="flex" gap={1} alignItems="center">
            <Select
              width={164}
              onChange={onChangeSorting}
              initialValue={`Sort By ${capitalize(
                filters?.sorting?.orderBy,
                true,
              )}`}
              items={filters?.sorting?.items}
            />
            <SortButton
              onClick={onChangeSorting(null, filters?.sorting?.order)}
              order={filters?.sorting?.order}
            />
          </Box>
        </Box>
        {renderImportAddressButton()}
      </>
    );
  }, [
    onAddAddress,
    isAddressBookPage,
    isMobileMode,
    filters,
    onChangeSorting,
    classes,
    importAddresses,
    isCartPage,
  ]);

  return <Box className={classes.filtersBox}>{renderBox()}</Box>;
};

export default FiltersBox;
